import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export const AccountProfilesTab = ({
  data
}) => {
  return <div data-id="element-268">
      <h2 className="text-lg font-medium mb-4" data-id="element-269">Account Profiles</h2>
      <div className="overflow-hidden border border-gray-200 rounded-lg mb-6" data-id="element-270">
        <table className="w-full" data-id="element-271">
          <thead className="bg-gray-50" data-id="element-272">
            <tr data-id="element-273">
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-500" data-id="element-274">
                Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-500" data-id="element-275">
                Role
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-500" data-id="element-276">
                Ownership
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-500" data-id="element-277">
                Status
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-500" data-id="element-278"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-279">
            {data.applicants.map((applicant, index) => <tr key={index} data-id="element-280">
                <td className="px-4 py-4 text-sm text-gray-900 font-medium" data-id="element-281">
                  {applicant.name}
                </td>
                <td className="px-4 py-4 text-sm text-gray-500" data-id="element-282">
                  {applicant.role}
                </td>
                <td className="px-4 py-4 text-sm text-gray-500" data-id="element-283">
                  {applicant.ownership}
                </td>
                <td className="px-4 py-4 text-sm" data-id="element-284">
                  <span className={`px-2 py-1 rounded-full text-xs ${applicant.status === 'Verified' ? 'bg-green-50 text-green-600' : 'bg-yellow-50 text-yellow-600'}`} data-id="element-285">
                    {applicant.status}
                  </span>
                </td>
                <td className="px-4 py-4 text-sm text-[#5c5cf5]" data-id="element-286">
                  <button className="flex items-center" data-id="element-287">
                    View <ChevronRightIcon size={16} className="ml-1" data-id="element-288" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <button className="bg-[#5c5cf5] text-white py-3 px-6 rounded-full font-medium" data-id="element-289">
        Add another applicant
      </button>
    </div>;
};